// extracted by mini-css-extract-plugin
export default {"header":"CommercialPresentation_header__xOCAY","headerImage":"CommercialPresentation_headerImage__zcJiq"};